import { gql } from "@apollo/client";

export const RolePermissionQueries = {
  SITE_MODULE_PERMISSION_LIST: gql`
    query SiteModulePermissionList($sitename: String!) {
      authoring_siteModulePermissionList(sitename: $sitename)
    }
  `,
};
